import _extends from "@babel/runtime/helpers/esm/extends";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["children", "className"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { misc, text } from '../assets/styles/utility';
import Container from './Container';
import { jsx as ___EmotionJSX } from "@emotion/react";

const StylesSubnavVariables = theme => ({
  height: theme.height.large
});

export const SubnavMenuItemStyles = theme => [_objectSpread(_objectSpread({
  color: theme.fontColor.muted,
  display: 'block',
  height: StylesSubnavVariables(theme).height,
  lineHeight: `${StylesSubnavVariables(theme).height}px`,
  position: 'relative',
  fontSize: theme.fontSize.small,
  fontWeight: theme.fontWeight.bold
}, text.expanded(theme)), {}, {
  transition: `color ${theme.timing.base} ${theme.transition.base}`,
  '&:hover, &:focus': {
    color: theme.fontColor.base
  },
  '&[disabled]': {
    opacity: theme.opacity.base,
    cursor: 'not-allowed',
    pointerEvents: 'none'
  },
  '&.is-active': {
    color: theme.fontColor.base,
    '&::before': {
      content: "''",
      position: 'absolute',
      left: 0,
      width: '100%',
      bottom: 0,
      height: 3,
      background: theme.color.primary.base
    }
  }
})];

const Subnav = _ref => {
  let {
    children,
    className
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    css: /*#__PURE__*/_css({
      background: theme.brand.stone50,
      borderBottom: theme.border.large
    }, process.env.NODE_ENV === "production" ? "" : ";label:Subnav;"),
    className: clsx('CK__Subnav', className)
  }, rest), ___EmotionJSX(Container, {
    css: [misc.overflow, {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: StylesSubnavVariables(theme).height
    }, process.env.NODE_ENV === "production" ? "" : ";label:Subnav;"]
  }, children));
};

export default Subnav;